import styled from 'styled-components';
import { colors } from "../../utils/colors";
import SustainabilityHeaderImg from '../../assets/home/big-line.jpg'
import BottomLineImg from '../../assets/home/bottom-line.svg'

export const Background = styled.div`
    position: relative;
    width: 100vw;
    min-height: 100vh;
    background-color: white;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    padding: 0px 0px 100px;
`;

export const SustainabilityHeader = styled.div`
    width: 100vw;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    background: url(${SustainabilityHeaderImg});
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 800px) {
        height: 600px;
    }

    div{
        color: white;
        width: 50%;

        @media (max-width: 1200px) {
            width: 90%;
        }

        h1{
            font-family: 'Courgette', cursive;
            text-align: center;
            margin-bottom: 40px;
            text-transform: uppercase;
        }
        p{
            margin-bottom: 20px;
        }
    }
`;

export const SustainabilityTittleDiv = styled.div`
    padding: 0px 60px;
    width: 100%;
    text-align: center;

    @media (max-width: 1200px) {
        padding: 0px 40px;
    }

    @media (max-width: 800px) {
        padding: 0px 20px;
    }
`;

export const SustainabilityTittleUpText = styled.h1`
    color: ${colors.CREAM};
    font-family: 'Courgette', cursive;
    text-align: center;
`;

export const SustainabilityText = styled.p`
    color: ${colors.CREAM};
    font-family: 'Markazi Text', serif;
    text-align: center;
`;

export const SustainabilityTittle = styled.img`
    width: ${props => props.smaller ? '60%' : '80%' };
    max-width: ${props => props.smaller ? '400px' : '600px' };
    margin: 30px 0;

    @media (max-width: 800px) {
        margin: 50px 0;
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${(props) => props.center ? 'center' : 'space-between'};
    width: 100vw;
    padding: 20px 60px;

    @media (max-width: 1200px) {
        flex-direction: ${(props) => props.reverse ? 'column-reverse' : 'column'};
        padding: 0 40px;
    }

    @media (max-width: 800px) {
        padding: 0 20px;
    }
`;

export const TapsImage = styled.img`
    width: ${(props) => props.solo ? '100%' : '50%'};
    margin: ${(props) => props.solo ? '50px 0 0' : '10px'};

    @media (max-width: 1200px) {
        width: 90%;
    }
`;

export const SustainabilityBottomLine = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100px;
    overflow: hidden;
    background: url(${BottomLineImg});
    background-repeat: no-repeat;
    background-size: cover;
`;
